import { AppDispatch } from "@/app/store";

export default function getActions(dispatch: AppDispatch) {
  return {
    dispatch,
  }
}
